import { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import { useProductStore } from "@/_zustand/store";
import { useAuth } from "@/_zustand/auth";
import {
  hayPagoEnCurso,
  generarBuyOrderOneClick,
  PAYMENT_MSG_EN_CURSO,
} from "@/lib/paymentGuard";

export const PayWithDiscountButton = () => {
  const navigate = useNavigate();
  const isCompanyFlow = location.pathname.startsWith("/company");
  const { setBuyOrder } = useProductStore();
  const { statusAuth } = useAuth();
  const [navegando, setNavegando] = useState(false);

  const authorizeTransaction = () => {
    if (navegando) return;
    if(statusAuth != 'authed'){
      toast.error("Debe validar su correo para continuar");
      return;
    }
    // Comparte el candado con OneClick: un pago OneClick en curso en esta
    // pestaña no debe poder solaparse con "pagar con descuento".
    if (hayPagoEnCurso("paywithdiscount") || hayPagoEnCurso("oneclick")) {
      toast.error(PAYMENT_MSG_EN_CURSO);
      return;
    }

    setNavegando(true);
    let buyOrder = generarBuyOrderOneClick();
    setBuyOrder(buyOrder);
    navigate(isCompanyFlow ? '/company/pay-detail?platform=paywithdiscount' : '/pay-detail?platform=paywithdiscount', { replace: true });
  }

  return (
    // <Button className="btn verde text-white inter-semibold mx-1" size="md" onClick={ () => authorizeTransaction()}>
    //   Pagar
    // </Button>
    <button
      type="submit"
      className="order-btn-fill"
      style={{minWidth:"150px"}}
      disabled={navegando}
      onClick={ () => authorizeTransaction()}
    >
    Pagar
</button>
  )
}
